import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import './TextDivTemp.css'
//import { ReactComponent as DefaultTextBackground } from '../../../../../Utilities/defaultText.svg'
import ContentEditable from 'react-contenteditable'


const wStyles = theme => ({
    ImageIconAdjusted:{
        width:"100%",
        height:"100%"
    }
})

class TextDivTemp extends Component {
    constructor(props){
        super(props)
        this.state={
            editable:true,
            //story:`<p>於此編輯文字區塊</p>`
        }
        this.contentEditableRef = React.createRef()
        this.textRef= React.createRef()
    }

    componentDidMount(){
        this.initialState()
        window.addEventListener("resize", this.getResizeHeight)
        this.getResizeHeight()
    }

    componentDidUpdate(prevProps){
        if(prevProps.textSize !== this.props.textSize)
        {
            this.resizeTextContainer()
        }
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.getResizeHeight)
    }

    initialState=()=>{
        if(this.props.textAttributes && this.props.textAttributes.story)
        {
           
            this.setState({
                story:this.props.textAttributes.story
            })
        }
    }

    
    getResizeHeight=()=>{
        console.log("TextDiv Resizing...")
        let tempHeight = this.textRef.current.scrollHeight
        console.log("resizeHeight : ", tempHeight)
        console.log(this.textRef)
        console.log(this.contentEditableRef)
        this.props.getResizeHeight(tempHeight)
    }

    resizeTextContainer=()=>{
        let textDivDom = this.contentEditableRef.current
        textDivDom.style.width = this.props.textSize.width
        textDivDom.style.height = this.props.textSize.height
    }

    detectUrlProps=()=>{
        // let svgStyle = {
        //     width:"100%",
        //     height:"100%",
        //     position:"absolute"    
        // }

        if(this.props.textAttributes.background)
        {
            return null
        }
        else
        {
            return null
            //return(<DefaultTextBackground style={svgStyle}/>)
        }
    }

    getWidth=()=>{
        return this.props.textSize.width
    }

    getHeight=()=>{
        return this.props.textSize.height
    }

    getFontColor=()=>{
        if(this.props.textAttributes.font)
        {
            return this.props.textAttributes.font.color
        }
        else
        {
            return null
        }
    }

    getHtml=()=>{
        if(this.props.textAttributes && this.props.textAttributes.story)
        {
            let preStory = this.props.textAttributes.story.replace(/!es#/g,'"')
            return preStory

        }
        else
        {
            return `<p>於此編輯文字區塊</p>`
        }            
    }

    getFontSize=()=>{
        if(this.props.textAttributes.font)
        {
            return this.props.textAttributes.font.size
        }
        else
        {
            return null
        }
    }

    getFontFamily=()=>{
        if(this.props.textAttributes.font)
        {
            if(this.props.textAttributes.font.eFamily !=="none" && this.props.textAttributes.font.cFamily !=="none")
            {
                return "'"+this.props.textAttributes.font.eFamily+"','"+this.props.textAttributes.font.cFamily+"'"
            }
            else if(this.props.textAttributes.font.eFamily !=="none" && this.props.textAttributes.font.cFamily ==="none")
            {
                return this.props.textAttributes.font.eFamily
            }
            else if(this.props.textAttributes.font.eFamily ==="none" && this.props.textAttributes.font.cFamily !=="none")
            {
                return this.props.textAttributes.font.cFamily
            }
            else
            {
                return null
            }
        }
        else
        {
            return null
        }
    }

    overflowCheck=()=>{
        if(this.props.previewMode)
        {
            return null
        }
        else
        {
            return "hidden"
        }
    }

    handleChange = (evt) => {
   
        let story = evt.target.value

        if(this.props.textAttributes && this.props.textAttributes.story)
        {
            let preStory = this.props.textAttributes.story.replace(/!es#/g,'"')

            if(preStory !== story)
            {      
                let result = story.replace(/"/g,'!es#')
                this.props.getStory(result)
            }
            else
            {
    
            }
        }
        else
        {
            let result = story.replace(/"/g,'!es#')
            this.props.getStory(result)
        }
    };

    toggleEditable = () => {
        this.setState({ editable: !this.state.editable });
    };

    handleOnFocus = (toggle) => {
        this.props.focusOnDiv(toggle)
    }

    textDivMouseUp = () => {
        console.log("TextDivTemp textDivMouseUp")
        if(document.getSelection())
        {
            let searchWord = document.getSelection().toString()
            console.log(searchWord)
            if(searchWord && searchWord !== "")
            {
                this.props.invokeHyperLinkSelection(searchWord)
            }           
        }
        else
        {
            console.log("Selection Null")
        }
    }

    render(){
        let notFocusingCompositionContainerStyle ={
            width:this.getWidth(),
            height:this.getHeight(),
            position:"relative",
            color:this.getFontColor(),
            overflow:this.overflowCheck(),
            fontSize:this.getFontSize()+'px',
            fontFamily:this.getFontFamily()
        }
        
        return(
            <div className={"TextDivContainer"} style={notFocusingCompositionContainerStyle} ref={this.textRef} onMouseUp={this.textDivMouseUp}>
                {this.detectUrlProps()}      
                <ContentEditable
                    innerRef={this.contentEditableRef}
                    className="editable"
                    html={this.getHtml()} 
                    disabled={!this.state.editable} 
                    onChange={this.handleChange} 
                    onFocus={(e)=>this.handleOnFocus(true)}
                    onBlur={(e)=>this.handleOnFocus(false)}
                    style={{"fontFamily":this.getFontFamily()}}
                />              
            </div>
        )
    }
}

export default withStyles(wStyles)(TextDivTemp)